import { render, staticRenderFns } from "./AbnormalBedtime.vue?vue&type=template&id=af5a6710&"
import script from "./AbnormalBedtime.vue?vue&type=script&lang=js&"
export * from "./AbnormalBedtime.vue?vue&type=script&lang=js&"
import style0 from "./AbnormalBedtime.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports